import React from 'react';
import { useDispatch } from 'react-redux';
import { apiAction } from '../../../store/generalSlice';

const customEventTypes = [
  'ADD_PAYMENT_INFO',
  'ADD_TO_CART',
  'ADD_TO_WISHLIST',
  'COMPLETE_REGISTRATION',
  'CONTACT',
  'CUSTOMIZE_PRODUCT',
  'DONATE',
  'FIND_LOCATION',
  'INITIATE_CHECKOUT',
  'LEAD',
  'LISTING_INTERACTION',
  'PURCHASE',
  'SCHEDULE',
  'SEARCH',
  'START_TRIAL',
  'SUBMIT_APPLICATION',
  'SUBSCRIBE',
  'VIEW_CONTENT',
];

const PromotedObject = (props) => {
  const dispatch = useDispatch();
  const { action, fieldName, field, state, setState } = props;

  const updateValue = (e, fieldName) => {
    setState((prevState) => {
      if (typeof prevState[field.id].value !== 'object') {
        return {
          ...prevState,
          [field.id]: {
            ...prevState[field.id],
            value: { [fieldName]: e.target.value },
          },
        };
      }
      return {
        ...prevState,
        [field.id]: {
          ...prevState[field.id],
          value: { ...prevState[field.id].value, [fieldName]: e.target.value },
        },
      };
    });
  };

  const SaveButton = () => {
    return (
      <>
        <button
          className='btn btn-sm btn-success mt-2'
          onClick={() => {
            dispatch(
              apiAction({
                reduxField: 'action',
                route: `actions/updateDuplicateAction`,
                actionId: action._id,
                fieldName,
                changes: { ...state },
              })
            );
          }}
        >
          Save
        </button>
      </>
    );
  };

  return field && state && setState ? (
    <div key={field.id} className='col-md-6 p-3 border'>
      <label>
        <b>{field.id}: </b>
        {field.description}
      </label>
      <div>
        <label>pixel_id</label>
        <input
          type='text'
          className='form-control'
          defaultValue={typeof state[field.id]?.value === 'object' ? state[field.id].value.pixel_id : undefined}
          disabled={state[field.id] ? state[field.id].isUseSource : null}
          onChange={(e) => updateValue(e, 'pixel_id')}
        />
      </div>
      {state[field.id]?.value?.pixel_id !== action[fieldName][field.id]?.value?.pixel_id ? <SaveButton /> : null}
      <div>
        <label>custom_event_type</label>
        <select
          className='form-control'
          value={typeof state[field.id]?.value === 'object' ? state[field.id].value.custom_event_type : undefined}
          onChange={(e) => updateValue(e, 'custom_event_type')}
          disabled={state[field.id] ? state[field.id].isUseSource : null}
        >
          <option value={''}>Choose Value</option>
          {customEventTypes.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
        {state[field.id]?.value?.custom_event_type !== action[fieldName][field.id]?.value?.custom_event_type ? (
          <SaveButton />
        ) : null}
      </div>
      <div className='form-check mt-2'>
        <input
          type='checkbox'
          className='form-check-input'
          checked={state[field.id] ? state[field.id].isUseSource : null}
          onChange={(e) => {
            setState((prevState) => {
              return {
                ...prevState,
                [field.id]: { ...prevState[field.id], isUseSource: e.target.checked },
              };
            });
            dispatch(
              apiAction({
                reduxField: 'action',
                route: `actions/updateDuplicateAction`,
                actionId: action._id,
                fieldName,
                changes: { ...state, [field.id]: { ...state[field.id], isUseSource: e.target.checked } },
              })
            );
          }}
        />
        <label className='form-check-label'>Use Source</label>
      </div>
    </div>
  ) : null;
};

export default PromotedObject;
